export default "<p-footer>\r\n    <ng-content></ng-content>\r\n</p-footer>";